<app-dashboard-loading *ngIf="loadingDashboard"></app-dashboard-loading>

<div class="animation-focus-in animate-duration-1s" *ngIf="!loadingDashboard">
	<div class="d-flex card w-100">
		<div class="p-grid">
			<div class="p-col-12 p-md-10 d-flex flex-column">
				<div class="display-8 ms-1 mt-2 mb-1">
					<span *ngIf="venueService.subscriptionVenue.value.name">
						{{ venueService.subscriptionVenue.value.name }}
					</span>
					<p-skeleton *ngIf="!venueService.subscriptionVenue.value.name" styleClass="display-8"></p-skeleton>
				</div>

				<div class="display-14 bigtext ms-2 mt-2 mb-1">
					<p-skeleton *ngIf="!venueService.subscriptionOOvenue.value.address1"></p-skeleton>
					<span *ngIf="venueService.subscriptionOOvenue.value.address1" class="p-color">
						{{ venueService.subscriptionOOvenue.value.address1 }} {{ venueService.subscriptionOOvenue.value.city }}
						{{ venueService.subscriptionOOvenue.value.state }} {{ venueService.subscriptionOOvenue.value.zip }}
					</span>
				</div>
			</div>
			<div class="p-col-12 p-md-2 ms-auto d-flex flex-column">
				<p-dropdown
					#idValue
					[options]="dashboardOptions"
					optionLabel="label"
					optionValue="value"
					optionDisabled="disabled"
					name="idValue"
					[(ngModel)]="selectedDashboard"
					[style]="{ width: '100%' }"
					styleClass="ms-auto"
					appendTo="body"
				></p-dropdown>

				<div (click)="setDashboardAsFavorite()" class="ms-auto p-text-italic fc-font-size-xs">set as favorite</div>
			</div>
		</div>
		<div class="d-flex flex-wrap" *ngIf="selectedDashboard !== 4">
			<div class="display-14 ms-auto d-flex">
				<div class="p-grid">
					<div class="col-1" (click)="checkDateChange('prev')">
						<span [ngClass]="dateSelectorEnabled.prev ? 'fl-text-black' : 'fl-text-disabled'">
							<fa-icon [icon]="['fas', 'left']" size="lg" class="my-auto"></fa-icon>
						</span>
					</div>
					<div class="col-10 d-flex">
						<div class="mx-auto my-auto">
							{{ app.moment(currentCheckDate, "MMDDYYYY").format("ddd, MMM D, YYYY") }}
						</div>
					</div>
					<div class="col-1" (click)="checkDateChange('next')">
						<span [ngClass]="dateSelectorEnabled.next ? 'fl-text-black' : 'fl-text-disabled'">
							<fa-icon [icon]="['fas', 'right']" size="lg" class="my-auto"></fa-icon>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="w-100">
		<app-sales-dash
			#salesDash
			*ngIf="selectedDashboard === 1"
			[(checkDate)]="currentCheckDate"
			[(currentDaySalesSummary)]="currentDaySalesSummary"
		></app-sales-dash>
		<app-labor-dash
			#laborDash
			*ngIf="selectedDashboard === 2"
			[(checkDate)]="currentCheckDate"
			[(currentDaySalesSummary)]="currentDaySalesSummary"
		></app-labor-dash>
		<app-item-dash
			#itemDash
			*ngIf="selectedDashboard === 3"
			[(checkDate)]="currentCheckDate"
			[(currentDaySalesSummary)]="currentDaySalesSummary"
		></app-item-dash>
		<app-online-dash #onlineDash *ngIf="selectedDashboard === 4"></app-online-dash>
	</div>
</div>
